module.exports = __webpack_public_path__ + "static/img/Team_spirit3.97f9696.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/Team_spirit3.png
// module id = AlTR
// module chunks = 0